<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1085 -644)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1085 644)" />
			<path
				d="M13.75,11.5A3.75,3.75,0,1,0,10,7.75,3.761,3.761,0,0,0,13.75,11.5Zm0,3.75A3.75,3.75,0,1,0,17.5,19,3.761,3.761,0,0,0,13.75,15.25Zm0,11.25a3.75,3.75,0,1,0,3.75,3.75A3.761,3.761,0,0,0,13.75,26.5Z"
				transform="translate(1093.75 647.5)"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-more-vertical',
	components: {},
	computed: {},
	props: {}
};
</script>

<style scoped lang="scss">
.a {
	fill: none;
}
</style>

<docs>
    IconMoreVertical

    ```js
    <b-icon-more-vertical />
    ```
</docs>
